import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useFirestore } from '../hooks/useFirestore';
import ReviewForm from '../components/ReviewForm';
import MapView from '../components/MapView';

const ProviderDetailsPage = () => {
  const { id } = useParams();
  const [provider, setProvider] = useState(null);
  const [reviews, setReviews] = useState([]);
  const { getProviderDetails, getProviderReviews } = useFirestore();

  useEffect(() => {
    const fetchProviderDetails = async () => {
      const providerData = await getProviderDetails(id);
      setProvider(providerData);
      const providerReviews = await getProviderReviews(id);
      setReviews(providerReviews);
    };
    fetchProviderDetails();
  }, [id, getProviderDetails, getProviderReviews]);

  if (!provider) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">{provider.name}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Información del Proveedor</h2>
          <p><strong>Email:</strong> {provider.email}</p>
          <p><strong>Teléfono:</strong> {provider.phone}</p>
          <p><strong>Especialidad:</strong> {provider.specialty}</p>
          <p><strong>Descripción:</strong> {provider.description}</p>

          <h3 className="text-xl font-semibold mt-6 mb-4">Ubicación</h3>
          <MapView markers={[{ lat: provider.lat, lng: provider.lng, name: provider.name }]} />
        </div>
        <div>
          <h2 className="text-2xl font-semibold mb-4">Reseñas</h2>
          {reviews.map(review => (
            <div key={review.id} className="mb-4 p-4 bg-gray-100 rounded-lg">
              <p><strong>Calificación:</strong> {review.rating}/5</p>
              <p>{review.comment}</p>
            </div>
          ))}
          <ReviewForm providerId={id} />
        </div>
      </div>
    </div>
  );
};

export default ProviderDetailsPage;